import React from "react";
import Nav from "../components/nav/Nav";
import Footer from "../components/footer/Footer";
import "./ResetPasswordPage.css";

function ResetPasswordPage() {

  return (
    <div className="reset-container">
      <Nav />
      <div className="page-content reset-content">
        <h2>RESET PASSWORD ❌ UNAVAILABLE</h2>
        <p>This feature is coming  🔜</p>
        <p>We apologize for the inconvenience 😢</p>
        <p>Please contact us through the support email 📧</p>
        <button><a href="mailto:info@getinlinebrand.com">Contact Support</a></button>
      </div>
      <Footer />
    </div>
  );

}

export default ResetPasswordPage;
